// External
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/sharp-solid-svg-icons";

// Internal
import { getDataTestId } from "../functions/data-test-ids";
import { AppFont, IconType } from "../icons/icons";
import { Tooltip } from "../tooltip/tooltip.jsx";
import { ModalSidebarItemStatus } from "./modal-constants";

function ModalSidebarItemStatusDot(props) {
    const getStatusClass = () => {
        switch (props.Status) {
            case ModalSidebarItemStatus.Incomplete:
                return "eone-ui-modal-sidebar-item-status-dot-incomplete";
            case ModalSidebarItemStatus.Complete:
                return "eone-ui-modal-sidebar-item-status-dot-complete";
            case ModalSidebarItemStatus.Error:
                return "eone-ui-modal-sidebar-item-status-dot-error";
            default:
                return null;
        }
    };

    const statusClass = getStatusClass();
    if (!statusClass) {
        return null;
    }

    return (
        <FontAwesomeIcon
            icon={faCircle}
            className={"eone-ui-modal-sidebar-item-status-dot " + statusClass} />
    );
}

function ModalSidebarItem(props) {
    const onClick = () => {
        if (typeof props.OnChange === "function") {
            props.OnChange(props.Value);
        }
    };

    const getClassName = () => {
        if (props.Active) {
            return "eone-ui-modal-sidebar-item eone-ui-modal-sidebar-item-active";
        }
        return "eone-ui-modal-sidebar-item";
    };

    const renderIcon = () => {
        if (!props.Icon) return null;
        if (props.IconType === IconType.AppFont) {
            return <AppFont Icon={props.Icon} />;
        }
        return <FontAwesomeIcon icon={props.Icon} fixedWidth />;
    };

    return (
        <button
            type="button"
            className={getClassName()}
            data-testid={getDataTestId(props.DataTestId, props.Value)}
            onClick={onClick}>
            {renderIcon()}
            <div className="eone-ui-modal-sidebar-item-label">{props.Label}</div>
            <ModalSidebarItemStatusDot Status={props.Status} />
            <Tooltip
                Title={props.TooltipTitle || props.Label}
                Tooltip={props.Tooltip}
                DataTestId={props.DataTestId} />
        </button>
    );
}

export function ModalSidebar(props) {
    const onChange = (value) => {
        if (typeof props.OnChange === "function") {
            props.OnChange(value);
        }
    };

    const getItems = () => {
        if (!props.Items) {
            return null;
        }
        return props.Items.map((item, index) => {
            if (item.Visible !== undefined && !item.Visible) {
                return null;
            }
            return (
                <ModalSidebarItem
                    key={index}
                    Value={item.Value}
                    Label={item.Label}
                    Icon={item.Icon}
                    IconType={item.IconType}
                    Status={item.Status}
                    Active={item.Value === props.Value}
                    OnChange={onChange}
                    Tooltip={item.Tooltip}
                    TooltipTitle={item.TooltipTitle}
                    DataTestId={props.DataTestId} />
            );
        });
    };

    if (props.Visible !== undefined && !props.Visible) {
        return null;
    }

    return (
        <div className="eone-ui-modal-sidebar" data-testid={props.DataTestId}>
            {getItems()}
        </div>
    );
}
